import React, { useEffect, useState } from 'react'

export const RefreshContentContext = React.createContext([])

export const useRefreshContent = () => React.useContext(RefreshContentContext)

export const RefreshPanel = (props) => {
  const [refreshContent, setRefreshContent] = useState(false)
  const { children } = props

  useEffect(() => {
    if (refreshContent) setRefreshContent(false)
  }, [refreshContent])

  return (
    <RefreshContentContext.Provider value={[refreshContent, setRefreshContent]}>
      {children}
    </RefreshContentContext.Provider>
  )
}

export const RefreshItem = (props) => {
  const [refreshContent] = useRefreshContent()
  const { children } = props

  return <>{!refreshContent ? children : <></>}</>
}
